import type { RecipeColumnState } from './types';

/** Match legacy Recipe.html: column.color, else group.color. */
export function resolveRecipeColumnBackground(
  column: Pick<RecipeColumnState, 'color'>,
  groupColor?: string
): string | undefined {
  const bg = column.color || groupColor;
  return bg || undefined;
}
